import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import PageHeadingSection from '../../../common/pageheading/PageHeadingSection';
import Breadcrumbs from '../../../common/BreadCrum/BreadCrum';
import SectionTab from '../../../common/sectiontab/SectionTab';

import NewsList from './NewsList';
import Notices from '../Notices/Notices';

const NewsLettersMain = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.activeTab || "newsletter");
    
    // Using a ref or simple state to trigger the Notice form opening
    // Or even better, we can pass a trigger function down to Notices, but we can't easily do that through SectionTab.
    // Let's use a custom event or a context, or simply render Notices differently.
    // Wait, since SectionTab renders the component as `<ActiveComponent />`, we can't pass props easily.
    // For Newsletter, Add goes to a new route, so it's easy.
    // For Notice, Add opens a form inside Notices. We might need a global state or to pass an `isAdding` prop.
    
    // Instead of passing props, since `SectionTab` just instantiates the component, we can customize `SectionTab` usage.
    
    const tabs = [
        {
            key: "newsletter",
            label: "Newsletter",
            component: NewsList
        },
        {
            key: "notices",
            label: "Notices",
            component: Notices
        }
    ];
    
    // Let's create an event dispatcher for Notices.
    const handlePrimaryClick = () => {
        if (activeTab === 'newsletter') {
            navigate('/zentres/News-Letters/add');
        } else if (activeTab === 'notices') {
            // Dispatch a custom event that Notices.jsx will listen to
            window.dispatchEvent(new CustomEvent('openNoticeForm'));
        }
    };

    return (
        <div className="bg-white px-6 py-4 border flex flex-col rounded-lg flex-1 overflow-y-auto gap-6 pt-4 scrollbar-hide">
            <Breadcrumbs />
            <PageHeadingSection
                Navbar={true}
                mainHeading="Communications"
                subHeading="Manage community newsletters and general notices"
                primaryBtnText={activeTab === 'newsletter' ? "Add Newsletter" : "Add Notice"}
                primaryBtnIcon={faPlus}
                PrimaryOnClick={handlePrimaryClick}
            />
            
            <div className="shrink-0 flex-1 flex flex-col">
                <SectionTab 
                    tabs={tabs} 
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                />
            </div>
        </div>
    );
};

export default NewsLettersMain;
